function googleTranslateElementInit() {
    new google.translate.TranslateElement({
        pageLanguage: 'en',
        gaTrack: false,
        gaId: ''
    }, 'google_translate_element');

    // remove the extra google translate added h1
    document.querySelector('#goog-gt-tt').remove();
}

// generate the google translate external source JS link
var googleTranslateScript = document.createElement('script');
googleTranslateScript.type = 'text/javascript';
googleTranslateScript.async = false;
googleTranslateScript.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';

// insert the generated JS link into the DOM head
document.querySelector('body').appendChild(googleTranslateScript);

$(document).on('ready', function () {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            // get the added nodes in the DOM
            var nodes = Array.prototype.slice.call(mutation.addedNodes);

            nodes.forEach(function (node) {
                // select the option element has "Select Language"
                if ($(node).is('option') && $(node).text() === 'Select Language') {

                    // change the text of the option to "Translate"
                    $(node).text('Translate');
                }
            });
        });
    });

    // listen to the node changes within #google_translate_element element
    observer.observe(document.querySelector("#google_translate_element"), {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
    });
});
